import { render, staticRenderFns } from "./FeatureScreenshot.vue?vue&type=template&id=9266dab2&scoped=true&"
import script from "./FeatureScreenshot.vue?vue&type=script&lang=ts&"
export * from "./FeatureScreenshot.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureScreenshot.vue?vue&type=style&index=0&id=9266dab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9266dab2",
  null
  
)

export default component.exports